import { CallbackObject } from 'api/core/get-page-function';
import { GetOrderItemsVm } from './get-order-items.vm';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

export const getOrderItems = async (order: string, offset: string, callback: CallbackObject<GetOrderItemsVm>) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
      offset,
      orderId: order,
    },
  };

  try {
    const res: AxiosResponse = await instance.get(`/reception/order-items`, config);
    callback.success(plainToClass(GetOrderItemsVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
